import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonContinue } from '../common/Button/ButtonContinue';

interface Props {
  showDialog: boolean;
  title: string;
  content: string;
  onCloseModal: () => void;
}

const FooterLegalDocument = ({
  showDialog,
  title,
  content,
  onCloseModal
}: Props): JSX.Element => {
  const onClickClose = () => {
    onCloseModal();
  };

  return (
    <Modal
      role='modal-popup'
      isOpen={showDialog}
      className={`footer-legal-doc modal-wide-component`}
      toggle={onClickClose}>
      <ModalHeader toggle={onClickClose}>{title}</ModalHeader>
      <ModalBody>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='modal-btn-continue'
          text='Close'
          onClick={onClickClose}
          additionalClassNames='btn-ok'
        />
      </ModalFooter>
    </Modal>
  );
};

export default FooterLegalDocument;
